import { call, put, takeEvery } from "redux-saga/effects";
import { ngayNghiLeApi } from "../../../api/category/ngayNghiLeApi";
import { INgayNghiLe } from "../../../model/respone/category/INgayNghiLe";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eNgayNghiLeActionIds,
  INgayNghiLeActionTypes,
} from "../../action-types/category/INgayNghiLeActions";
import { rootActions } from "../../actions/rootActions";
const mainAction = rootActions.category.ngayNghiLe;

export function* ngayNghiLeSaga(): any {
  yield takeEvery(eNgayNghiLeActionIds.LOAD_START, loadWorker);
  yield takeEvery(eNgayNghiLeActionIds.SAVE_START, saveWorker);
  yield takeEvery(eNgayNghiLeActionIds.DELETE_START, deleteWorker);
}
function* loadWorker(): any {
  const res: IBaseRespone = yield call(ngayNghiLeApi.SelectAll);
  if (res.is_success) {
    yield put(mainAction.LOAD_SUCCESS(res.data));
  } else {
    yield put(mainAction.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}
function* saveWorker(action: INgayNghiLeActionTypes): any {
  const payload = action.payload as INgayNghiLe;
  let res: IBaseRespone;
  if (payload.id > 0) {
    res = yield call(ngayNghiLeApi.Update, payload);
  } else {
    res = yield call(ngayNghiLeApi.Insert, payload);
  }
  if (res.is_success) {
    yield put(mainAction.SAVE_SUCCESS(res.data));
  } else {
    yield put(mainAction.SAVE_ERRR(res.message ?? "Có lỗi"));
  }
}
function* deleteWorker(action: INgayNghiLeActionTypes): any {
  const res: IBaseRespone = yield call(
    ngayNghiLeApi.Delete,
    action.payload as number
  );
  if (res.is_success) {
    yield put(mainAction.DELETE_SUCCESS(res.data));
  } else {
    yield put(mainAction.DELETE_ERRR(res.message ?? "Có lỗi"));
  }
}
